import { render, staticRenderFns } from "./centerLeft4.vue?vue&type=template&id=36024707&scoped=true&"
import script from "./centerLeft4.vue?vue&type=script&lang=js&"
export * from "./centerLeft4.vue?vue&type=script&lang=js&"
import style0 from "./centerLeft4.vue?vue&type=style&index=0&id=36024707&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36024707",
  null
  
)

export default component.exports